export default "__VITE_ASSET__CaRv5Nuz__"